import React from "react";
import "./rank-card.css";

const RankCard = ({ title, name, rank, icon, color }) => {
  const showRank = rank !== null && rank !== undefined && rank !== 0;
  const showName = name !== null && name !== undefined && name !== "";

  return (
    <div className="rank-card" style={{ border: `1.5px solid ${color}` }}>
      <div className="rank-row">
        <div className="rank-card-icon" style={{ color }}>
          {icon}
        </div>
        {showRank && <div className="card-rank">{rank}</div>}
      </div>
      <div className="card-title">{title}</div>
      {showName && <div className="rank-card-name">{name}</div>}
    </div>
  );
};

export default RankCard;
